// Excel error messages from copy/paste
export const INVALID_INPUT = [
  'Redirecting data. Wait a few seconds and try to cut or copy again',
  'Cannot cut or copy data from this page',
  'Cannot copy data from this page',
  'Cannot cut data from this page',
  'Cannot paste data from this page',
] as const;

export const MAX_CHAR_LENGTH = {
  TITLE: 100,
  SUBTITLE: 100,
  MESSAGE: 120,
} as const;
